/**
 * Общие константы ПС «ПОТОК».
 */

/** Версия контрактного пакета (semver внутри монорепо). */
export const SHARED_PACKAGE_VERSION = "0.0.0" as const;

/** Глобальный префикс HTTP API. */
export const API_V1_PREFIX = "api/v1" as const;

/** Префикс административных эндпоинтов. */
export const API_V1_ADMIN_PREFIX = "api/v1/admin" as const;

/** Имя сервиса API в health-check. */
export const API_SERVICE_NAME = "potok-api" as const;
